/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_State_DoneInputs */

const vi_station_work_state_done = /** @type {(inputs: Station_Work_State_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xong`)
};

/**

* @param {Station_Work_State_DoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_state_done = /** @type {((inputs?: Station_Work_State_DoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_State_DoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_state_done(inputs)
});